module.exports = __webpack_public_path__ + "static/media/thumbnail.2c9ae304.jpg";